// extracted by mini-css-extract-plugin
export default {"list":"PasswordRulesIndicator_list__6YKkp","item":"PasswordRulesIndicator_item__thFaB","text":"PasswordRulesIndicator_text__+ksD1"};